<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-crop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 5a1 1 0 011 1v5h25a1 1 0 011 1v21h5a1 1 0 011 1v2a1 1 0 01-1 1h-5v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5H10a1 1 0 01-1-1V15H4a1 1 0 01-1-1v-2a1 1 0 011-1h5V6a1 1 0 011-1h2zm23 10H13v18h22V15z"/></svg>
</template>
<script>

export default {
  name: 'IconCrop',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
